module.exports = __webpack_public_path__ + "static/opis-inwestycji-tablet-1ef1a579a30b62541507fa66ab3f9604.jpg";